import { useSelector } from 'react-redux';

import {
  getKnmIsBasicWatchOnlyWithoutCanceledFlag,
  getKnmIsCommonWatchOnly,
  getKnmIsEditableInStatusCommentsExist,
  getKnmIsEditEnabledByEditors,
  getKnmIsErknmStatusCommentsExist,
  getKnmIsErknmStatusDecisionAppealed,
  getKnmIsErknmStatusNotApprove,
  getKnmIsErknmStatusTypeCanceled,
  getKnmIsErknmStatusTypeCantBeCarryOut,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmWatchOnlyByTestUser,
} from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { getUserRoleIsSupervisor } from '../../../AuthPackage/MainModule/selectors/authSelectors';
import { ErknmApproveRemarkSectionCodeEnum } from '../../ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { useHasFieldApproveRemark } from '../common/useHasFieldApproveRemark';
import { getPlanListPlanErknmStatus } from '../../../PlanListPackage/MainModule/selectors/planListSelectors';
import { getIsPlanErknmStatusConsidered } from '../../../APIPackage/PlanListModule/common/getPlanErknmStatusFlags';

export const useIsStartDateEnabled = (isNewKnm: boolean, isCreateModal?: boolean) => {
  const isCommonWatchOnly = useSelector(getKnmIsCommonWatchOnly);
  const isBasicWatchOnlyWithoutCanceledFlag = useSelector(getKnmIsBasicWatchOnlyWithoutCanceledFlag);
  const isKnmEditEnabledByEditors = useSelector(getKnmIsEditEnabledByEditors);
  const isSupervisor = useSelector(getUserRoleIsSupervisor);
  const isKnmStatusCommentsExist = useSelector(getKnmIsErknmStatusCommentsExist);
  const isEditableInStatusCommentsExist = useSelector(getKnmIsEditableInStatusCommentsExist);
  const knmPlanStatus = useSelector(getPlanListPlanErknmStatus);
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isRemarksExists = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.DATES);
  const isKnmWatchOnlyByTestUser = useSelector(getKnmWatchOnlyByTestUser);
  const isKnmStatusWaitingCarryOut = useSelector(getKnmIsErknmStatusTypeWaitingCarryOut);
  const isKnmStatusCarriedOut = useSelector(getKnmIsErknmStatusTypeCarriedOut);
  const isKnmStatusNotApprove = useSelector(getKnmIsErknmStatusNotApprove);
  const isKnmStatusDecisionAppealed = useSelector(getKnmIsErknmStatusDecisionAppealed);
  const isKnmStatusCanceled = useSelector(getKnmIsErknmStatusTypeCanceled);
  const isKnmStatusCantBeCarryOut = useSelector(getKnmIsErknmStatusTypeCantBeCarryOut);

  // Для редактирования не новой - возвращаем стандартный параметр,
  // В других случаях - возвращаем составной без учета отмененных КНМ

  const isCommonWatchOnlyProperty = !isNewKnm
    ? isCommonWatchOnly
    : isBasicWatchOnlyWithoutCanceledFlag || !isKnmEditEnabledByEditors;

  return (
    !isCommonWatchOnlyProperty &&
    !isKnmWatchOnlyByTestUser &&
    isSupervisor &&
    (isNewKnm ||
      isEditableInStatusCommentsExist ||
      (isKnmStatusCommentsExist && isKnmPlanStatusConsidered && isRemarksExists) ||
      (isCreateModal &&
        (isKnmStatusWaitingCarryOut ||
          isKnmStatusCarriedOut ||
          isKnmStatusNotApprove ||
          isKnmStatusDecisionAppealed ||
          isKnmStatusCanceled ||
          isKnmStatusCantBeCarryOut)))
  );
};

export const useIsStopDateEnabled = (isNewKnm: boolean, isCreateModal?: boolean) => {
  return useIsStartDateEnabled(isNewKnm, isCreateModal);
};
